module.exports = __webpack_public_path__ + "static/media/folder_print.63ce4f02.ico";